import React from 'react'
import { Modal } from 'antd'
import { X, CheckCheck } from 'lucide-react'
import { Button } from '@/components/ui/button'

export interface ConfirmModalProps {
    isOpen: boolean
    title?: string
    description?: React.ReactNode
    cancelText?: string
    confirmText?: string
    onClose: () => void
    onConfirm?: () => void
    isLoading?: boolean
    variant?: 'danger' | 'info' | 'success'
    hideConfirm?: boolean
}

export function ConfirmModal({
    isOpen,
    title = 'Xác nhận',
    description = 'Bạn chắc chắn muốn thực hiện hành động này?',
    cancelText = 'Hủy',
    confirmText = 'Xác nhận',
    onClose,
    onConfirm,
    isLoading = false,
    variant = 'danger',
    hideConfirm = false,
}: ConfirmModalProps) {
    return (
        <Modal
            open={isOpen}
            onCancel={isLoading ? undefined : onClose}
            footer={null}
            closable={false}
            centered
            width={425}
            className="[&_.ant-modal-container]:!bg-white [&_.ant-modal-content]:!bg-white [&_.ant-modal-content]:!overflow-hidden"
        >
            <div className="absolute right-3 top-3 ">
                <Button
                    variant="ghost"
                    size="icon"
                    className="h-8 w-8"
                    onClick={onClose}
                    aria-label="Close"
                    disabled={isLoading}
                >
                    <X />
                </Button>
            </div>

            <div className="flex flex-col items-center pb-6 pt-3">
                {variant === 'danger' && (
                    <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#E44346]/20">
                        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#E44346]/30">
                            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#E44346] text-white shadow-sm">
                                <X size={16} strokeWidth={3} />
                            </div>
                        </div>
                    </div>
                )}

                {variant === 'info' && (
                    <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#0088FF40]">
                        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#0088FF]/40">
                            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#0088FF] text-white shadow-sm">
                                <span className="font-bold text-xl">?</span>
                            </div>
                        </div>
                    </div>
                )}

                {variant === 'success' && (
                    <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#34C75940]">
                        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#34C75940]">
                            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#00A550] text-white shadow-sm">
                                <CheckCheck size={16} strokeWidth={3} />
                            </div>
                        </div>
                    </div>
                )}

                <h3 className="text-xl font-bold text-[#1C2434] mb-3 mt-4">{title}</h3>
                <div className="text-sm text-[#1E2F41] text-center">{description}</div>
            </div>

            <div className={`flex gap-4 px-6 ${hideConfirm ? 'justify-center' : ''}`}>
                <Button
                    variant="outline"
                    size="lg"
                    className={hideConfirm ? 'min-w-[140px]' : 'flex-1'}
                    onClick={onClose}
                    disabled={isLoading}
                >
                    {cancelText}
                </Button>

                {!hideConfirm && onConfirm && (
                    <Button
                        variant="primary"
                        size="lg"
                        className="flex-1"
                        onClick={onConfirm}
                        loading={isLoading}
                    >
                        {confirmText}
                    </Button>
                )}
            </div>
        </Modal>
    )
}